module.exports = __webpack_public_path__ + "img/chart-line.6efde1c5.webp";